/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Segment, Dimmer, Loader } from 'semantic-ui-react';
import { TextField, Checkbox, FormControlLabel, ToggleButton, ToggleButtonGroup } from '@mui/material';
import 'firebase/compat/auth';
import axios from 'axios';
import server_config from './ServerConfiguration';
import FevirContext from './FevirContext';
import submitToFevirServer from './SubmitToFevirServer';
import { DataEntry } from './DataEntryFormFunctions';
const go_server_address = server_config["go_server_address"];

const EmptyBoxCharacter = () => {
  return <span className="box emptyBox">☐&nbsp;</span>;
}

const CTgovConvertPage = ({ useTitle, urlNCTid, nctIdFill }) => {

  useTitle("FEvIR ClinicalTrials.gov-to-FEvIR Converter");
  const globalContext = useContext(FevirContext);

  const [CTgovEntryState, setCTgovEntryState] = useState({ "nctid": urlNCTid || nctIdFill, "loadingSubmission": false });

  const [ctGovSearchState, setCtGovSearchState] = useState("");
  const [searchRecruitingState, setSearchRecruitingState] = useState(false);
  const [ctGovSearchResultsState, setCtGovSearchResultsState] = useState([]);
  const [ctGovSearchClicked, setCtGovSearchClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openAdvancedCTgovSearchState, setOpenAdvancedCTgovSearchState] = useState(false);
  const [advancedCTgovSearchState, setAdvancedCTgovSearchState] = useState({});
  const [advancedCtGovSearchClicked, setAdvancedCtGovSearchClicked] = useState(false);

  const [searchCondition, setSearchCondition] = useState("");
  const [searchOtherTerms, setSearchOtherTerms] = useState("");
  const [searchIntervention, setSearchIntervention] = useState("");
  const [searchLocation, setSearchLocation] = useState("");

  const [searchTitles, setSearchTitles] = useState("");
  const [searchOutcomeMeasure, setSearchOutcomeMeasure] = useState("");
  const [searchSponsor, setSearchSponsor] = useState("");
  const [searchLeadSponsor, setSearchLeadSponsor] = useState("");
  const [searchStudyIds, setSearchStudyIds] = useState("");
  const [searchFDAAAViolations, setSearchFDAAAViolations] = useState(false);

  const [searchStudyStatus, setSearchStudyStatus] = useState("all");
  const [searchSex, setSearchSex] = useState("all");
  const [searchStudyResultsType, setSearchStudyResultsType] = useState("all");
  const [searchAcceptsHealthyVolunteers, setSearchAcceptsHealthyVolunteers] = useState(false);
  const [searchPhase0, setSearchPhase0] = useState(false);
  const [searchPhase1, setSearchPhase1] = useState(false);
  const [searchPhase2, setSearchPhase2] = useState(false);
  const [searchPhase3, setSearchPhase3] = useState(false);
  const [searchPhase4, setSearchPhase4] = useState(false);
  const [searchPhaseNA, setSearchPhaseNA] = useState(false);
  const [searchStudyTypeInt, setSearchStudyTypeInt] = useState(false);
  const [searchStudyTypeObs, setSearchStudyTypeObs] = useState(false);
  const [searchStudyTypeObsPatReg, setSearchStudyTypeObsPatReg] = useState(false);
  const [searchStudyTypeExp, setSearchStudyTypeExp] = useState(false);
  const [searchStudyTypeExpIndiv, setSearchStudyTypeExpIndiv] = useState(false);
  const [searchStudyTypeExpInter, setSearchStudyTypeExpInter] = useState(false);
  const [searchStudyTypeExpTreat, setSearchStudyTypeExpTreat] = useState(false);
  const [searchDocumentsProtocols, setSearchDocumentsProtocols] = useState(false);
  const [searchDocumentsSAPs, setSearchDocumentsSAPs] = useState(false);
  const [searchDocumentsICFs, setSearchDocumentsICFs] = useState(false);

  const [searchFunderNIH, setSearchFunderNIH] = useState(false);
  const [searchFunderFed, setSearchFunderFed] = useState(false);
  const [searchFunderIndustry, setSearchFunderIndustry] = useState(false);
  const [searchFunderOther, setSearchFunderOther] = useState(false);

  const changeCTgovEntryState = (newValue, field) => {
    setCTgovEntryState(prevState => {
      return {
        ...prevState,
        [field]: newValue
      };
    });
  };

  const history = useHistory();

  const submitNCTId = async (nctid, redirect) => {
    if (nctid === undefined) {
      nctid = CTgovEntryState.nctid;
    }
    if (redirect === undefined) {
      redirect = true;
    }
    nctid = nctid.replaceAll(" ", "").replaceAll("\n", "");
    let nctIdList;
    if (nctid) {
      if (nctid.includes(",")) {
        nctIdList = [];
        for (let entry of nctid.split(",")) {
          if (entry && entry.length === 11) {
            nctIdList.push(entry);
          }
        }
      }
    } else {
      globalContext.openAlert({ header: "Please enter a NCT ID.", content: "" });
    }

    if (nctIdList?.length === 1) {
      nctid = nctIdList[0];
      nctIdList = undefined
    }

    if (nctIdList) {
      //Returns a list of titles for a list of NCT IDs
      //NCT06927973,NCT00408044
      ctGovSearch(nctIdList.join(","));
    } else {
      //Process as single NCTID entry
      changeCTgovEntryState(true, "loadingSubmission");
      const body = {
        'functionid': "submitnctid",
        'tool': "ctgovtofhirconverter",
        'idToken': "",
        'nctid': nctid || "",
        'addtodatabase': true,
        'status': "active",
      };

      let response = await submitToFevirServer(globalContext, 120000, body, true, false);

      if (response?.success) {
        if (redirect) {
          if (response.jobAlreadyRunning && response.message) {
            globalContext.openAlert({ "header": "Job Currently In Process", "content": response.message });
          } else if (response.numberOfResourcesCreated) {
            if (response.largeCollection) {
              const messageContent = "The ClinicalTrials.gov record was converted to " + response.numberOfResourcesCreated + " FHIR Resources. Click out to view the ResearchStudy Resource. Because the number of Resources created is so large, it may take a few minutes before the referenced Resources are loaded to the FEvIR Platform.";
              globalContext.openAlert({ "header": "Processing", "content": messageContent });
            } else {
              const messageContent = "The ClinicalTrials.gov record was converted to " + response.numberOfResourcesCreated + " FHIR Resources. Click out to view the ResearchStudy Resource.";
              globalContext.openAlert({ "header": "Complete", "content": messageContent });
            }
          } else if (response.message) {
            globalContext.openAlert({ "header": "", "content": response.message });
          }
          if (response.researchstudyfoi) {
            history.push(`/resources/ResearchStudy/${response.researchstudyfoi}`);
          }
        }
      } else if (response?.errormessage) {
        changeCTgovEntryState(false, "loadingSubmission");
        globalContext.openAlert({ "header": "Error", "content": response.errormessage });
      } else {
        changeCTgovEntryState(false, "loadingSubmission");
        const messageContent = "We were unable to convert this citation. Perhaps this NCT ID: " + nctid + " doesn't exist or there are issues in its structure.";
        globalContext.openAlert({ "header": "Error", "content": messageContent });
      }

    }

  };

  const handleKeyUp = (event) => {
    if (event.key === 'Enter' && !globalContext.alertModalState.open) {
      submitNCTId();
    }
  }

  const sleep = (ms) => {
    return new Promise(r => setTimeout(r, ms));
  }

  const updateAllCTgovConvertedResources = async () => {
    if (!globalContext.userState.loading && globalContext.userState.name === "Khalid Shahin") {
      let idToken = globalContext.userState.idToken;

      const body = {
        'functionid': 'getfhirresourceslist',
        'loadmyresources': false,
        'idToken': idToken
      };

      axios({
        method: 'POST',
        //url: server_address + ':' + ports["master_server"] + '/',
        url: go_server_address,
        timeout: 5000,
        data: body
      }).then(async (resp) => {
        if (resp?.data?.success) {
          setTimeout(() => { }, 600);
          for (let index in resp.data.resourceslist) {
            let resource = resp.data.resourceslist[index];
            let nctid = resource.nctid;
            if (nctid) {
              await submitNCTId(nctid, false);
              await sleep(16000);
            }
          }
          globalContext.openAlert({ "header": "All done!", "content": "" });
        }
      });
    }
  }

  const advancedCtGovSearchClick = async () => {
    if (globalContext.userState.firebaseuid) {
      setLoading(true);
      setAdvancedCtGovSearchClicked(false);
      if (advancedCTgovSearchState) {
        let searchQuery = JSON.parse(JSON.stringify(advancedCTgovSearchState));
        let body = {
          'functionid': 'getadvancedctgovsearchresults',
          'idToken': '',
          'searchQuery': searchQuery
        }
        let searchResultsResponse = await submitToFevirServer(globalContext, 60000, body, true, false);
        if (searchResultsResponse?.success) {
          if (searchResultsResponse.searchResults?.length) {
            setCtGovSearchResultsState(searchResultsResponse.searchResults);
          } else {
            alert("No search results.");
          }
        } else {
          alert("SUBMISSION FAILED.");
        }
      }
      setAdvancedCtGovSearchClicked(true);
      setLoading(false);
    } else {
      globalContext.openAlert({ "header": "Please login", "content": "Log into FEvIR to use this function." });
    }
  }

  const handleAdvancedCTgovKeyUp = (event) => {
    if (event.key === 'Enter' && !globalContext.alertModalState.open) {
      advancedCtGovSearchClick();
    }
  }

  const ctGovSearch = async (searchString) => {
    if (globalContext.userState.firebaseuid) {
      setLoading(true);
      setCtGovSearchClicked(false);
      let body = { "functionid": "addnctidsfromctgovsearch", "querySearchTypes": { "term": searchString }, "getSearchResults": true, "aggFilters": searchRecruitingState ? ["status%3Arec"] : undefined };
      let response = await submitToFevirServer(globalContext, 120000, body, true, false);
      if (response?.success) {
        //alert("Processing " + response.numberOfNctids + " records... It will be a while to be finished.");
        if (response.searchResults?.length) {
          if (response.searchResults.length > 19999) {
            alert("The search exceeded 20,000 results. Only the first 20,000 are shown here.");
          }
          setCtGovSearchResultsState(response.searchResults);
        } else {
          alert("No search results.");
        }
      } else {
        alert("SUBMISSION FAILED");
      }
      setCtGovSearchClicked(true);
      setLoading(false);
    } else {
      globalContext.openAlert({ "header": "Please login", "content": "Log into FEvIR to use this function." });
    }
  }

  const advancedCtGovSearch = async () => {

    if (globalContext.userState.firebaseuid) {
      setLoading(true);
      setCtGovSearchClicked(false);
      let aggFilters = [];
      if (searchSex) {
        if (searchSex === "f") {
          aggFilters.push("sex:f");
        } else if (searchSex === "m") {
          aggFilters.push("sex:m");
        }
        //If the value is "all" then nothing is pushed
      }
      if (searchStudyResultsType) {
        if (searchStudyResultsType === "with") {
          aggFilters.push("results:with");
        } else if (searchStudyResultsType === "without") {
          aggFilters.push("results:without");
        }
        //If the value is "all" then nothing is pushed
      }
      if (searchAcceptsHealthyVolunteers) {
        aggFilters.push("healthy:y");
      }
      if (searchPhase0 || searchPhase1 || searchPhase2 || searchPhase3 || searchPhase4 || searchPhaseNA) {
        let searchPhaseParameter = "phase:";
        if (searchPhase0) {
          searchPhaseParameter += "0%20";
        }
        if (searchPhase1) {
          searchPhaseParameter += "1%20";
        }
        if (searchPhase2) {
          searchPhaseParameter += "2%20";
        }
        if (searchPhase3) {
          searchPhaseParameter += "3%20";
        }
        if (searchPhase4) {
          searchPhaseParameter += "4%20";
        }
        if (searchPhaseNA) {
          searchPhaseParameter += "NA%20";
        }
        searchPhaseParameter = searchPhaseParameter.substring(0, searchPhaseParameter.length - 3); //Removes the last three characters
        aggFilters.push(searchPhaseParameter);
      }
      if (searchStudyTypeInt || searchStudyTypeObs || searchStudyTypeObsPatReg || searchStudyTypeExp || searchStudyTypeExpIndiv || searchStudyTypeExpInter || searchStudyTypeExpTreat) {
        let searchStudyTypeParameter = "studyType:";
        if (searchStudyTypeInt) {
          searchStudyTypeParameter += "int%20";
        }
        if (searchStudyTypeObs) {
          searchStudyTypeParameter += "obs%20";
        }
        if (searchStudyTypeObsPatReg) {
          searchStudyTypeParameter += "obs_patreg%20";
        }
        if (searchStudyTypeExp) {
          searchStudyTypeParameter += "exp%20";
        }
        if (searchStudyTypeExpIndiv) {
          searchStudyTypeParameter += "exp_indiv%20";
        }
        if (searchStudyTypeExpInter) {
          searchStudyTypeParameter += "exp_inter%20";
        }
        if (searchStudyTypeExpTreat) {
          searchStudyTypeParameter += "exp_treat%20";
        }
        searchStudyTypeParameter = searchStudyTypeParameter.substring(0, searchStudyTypeParameter.length - 3); //Removes the last three characters
        aggFilters.push(searchStudyTypeParameter);
      }
      if (searchDocumentsProtocols || searchDocumentsSAPs || searchDocumentsICFs) {
        let searchDocumentsParameter = "docs:";
        if (searchDocumentsProtocols) {
          searchDocumentsParameter += "prot%20";
        }
        if (searchDocumentsSAPs) {
          searchDocumentsParameter += "sap%20";
        }
        if (searchDocumentsICFs) {
          searchDocumentsParameter += "icf%20";
        }
        searchDocumentsParameter = searchDocumentsParameter.substring(0, searchDocumentsParameter.length - 3); //Removes the last three characters
        aggFilters.push(searchDocumentsParameter);
      }
      if (searchFunderNIH || searchFunderFed || searchFunderIndustry || searchFunderOther) {
        let searchFunderType = "funderType:";
        if (searchFunderNIH) {
          searchFunderType += "nih%20";
        }
        if (searchFunderFed) {
          searchFunderType += "fed%20";
        }
        if (searchFunderIndustry) {
          searchFunderType += "industry%20";
        }
        if (searchFunderOther) {
          searchFunderType += "other%20";
        }
        searchFunderType = searchFunderType.substring(0, searchFunderType.length - 3); //Removes the last three characters
        aggFilters.push(searchFunderType);
      }
      if (searchFDAAAViolations) {
        aggFilters.push("violation:y");
      }
      if (aggFilters.length === 0) {
        aggFilters = undefined;
      }
      let body = {
        "functionid": "addnctidsfromctgovsearch",
        "querySearchTypes": {
          "cond": searchCondition,
          "term": searchOtherTerms,
          "intr": searchIntervention,
          "locn": searchLocation, //Confused if this should be locnStr and HOW this is different from Facility Name
          "titles": searchTitles,
          "outc": searchOutcomeMeasure,
          "spons": searchSponsor,
          "lead": searchLeadSponsor,
          "id": searchStudyIds,
          ///"??? what should this be ???": searchFacility, //how is this different from location? API parameter-wise
          //"patient": "", //	See "PatientSearch Area" on Search Areas for more details. https://clinicaltrials.gov/data-api/about-api/search-areas#PatientSearch
        },
        "filterOverallStatus": searchStudyStatus === "recruitingAndNotYet" ? ["NOT_YET_RECRUITING", "RECRUITING"] : undefined,
        "getSearchResults": true,
        "aggFilters": aggFilters
        //"aggFilters": searchRecruitingState ? ["status%3Arec"] : undefined
      };
      let response = await submitToFevirServer(globalContext, 120000, body, true, false);
      if (response?.success) {
        //alert("Processing " + response.numberOfNctids + " records... It will be a while to be finished.");
        if (response.searchResults?.length) {
          if (response.searchResults.length > 19999) {
            alert("The search exceeded 20,000 results. Only the first 20,000 are shown here.");
          }
          setCtGovSearchResultsState(response.searchResults);
        } else {
          alert("No search results.");
        }
      } else {
        alert("SUBMISSION FAILED");
      }
      setCtGovSearchClicked(true);
      setLoading(false);
    } else {
      globalContext.openAlert({ "header": "Please login", "content": "Log into FEvIR to use this function." });
    }
  }

  const updateHistory = async () => {
    if (globalContext.userState.loading === false) {
      if (urlNCTid) {
        submitNCTId();
        history.replace("/ctgovconvert");
      } else if (nctIdFill) {
        history.replace("/ctgovconvert");
      }
    }
  }

  useEffect(() => {
    updateHistory();
  }, [globalContext.userState]);

  return (
    <div>
      <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
        {(loading) &&
          <Dimmer className={"loadingDimmer"} active inverted>
            <Loader inverted>Loading</Loader>
          </Dimmer>
        }
        <h2 style={{ textAlign: "center", color: "#AC3B61" }}>Computable Publishing<sup style={{ verticalAlign: "super", fontSize: "x-small" }}>®</sup>: ClinicalTrials.gov-to-FEvIR Converter</h2>
        {/*<Button style={{position: "absolute", right: "3px", top: "3px"}} className="formButton negative" content="✖" onClick={() => { history.push("/"); } } />*/}
        <br /><br />
        {/*I made it so you don't need to be logged in.*/}
        {true || globalContext.userState.firebaseuid ?
          <>
            <TextField style={{ width: "180px" }} className="inputField" type='text' size="small" variant='outlined' placeholder='NCT ID' value={CTgovEntryState.nctid} onKeyUp={handleKeyUp} onChange={(e) => { changeCTgovEntryState(e.target.value, "nctid"); }} />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Button className="formButton positive" content="Submit" compact onClick={() => submitNCTId()} disabled={CTgovEntryState.loadingSubmission} />
            {globalContext.userState.name === "Khalid Shahin" && <><Button className="formButton positive" content="UPDATE ALL NCTId Resources" compact onClick={updateAllCTgovConvertedResources} /></>}
            <br />
            <img className={CTgovEntryState.loadingSubmission ? 'visible' : 'invisible'} style={{ height: "22px" }} src="/spinner.gif" alt="Loading" />
            <div style={{ "textAlign": "left", "width": "100%" }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <h3>{CTgovEntryState.loadingSubmission ? <>Your requested ClinicalTrials.gov study record is being converted to</> : <><br />Enter an NCT Identifier to automatically create</>} HL7<sup>&#174;</sup> FHIR<sup>&#174;</sup> Resources.</h3><span>HL7<sup>&#174;</sup> and FHIR<sup>&#174;</sup> are the registered trademarks of Health Level Seven International and their use of these trademarks does not constitute an endorsement by HL7.</span>
            </div>
          </>
          :
          <p>Please login. (If you do not have an account click Sign In and log in with your Google Account.)</p>
        }
        <br /><br /><br />
        <TextField style={{ width: "960px" }} className="inputField" size="small" variant='outlined'
          placeholder='Search Terms' type='text'
          value={ctGovSearchState} onKeyUp={(event) => {
            if (event.key === 'Enter' && ctGovSearchState) {
              ctGovSearch(ctGovSearchState);
            }
          }}
          onChange={(e) => { setCtGovSearchState(e.target.value); }} />
        &nbsp;&nbsp;
        <Button className="formButton positive" content="Search" compact onClick={() => {
          if (ctGovSearchState) {
            ctGovSearch(ctGovSearchState);
          }
        }} disabled={loading} />
        <br />
        <div style={{ marginLeft: "16px", cursor: "pointer", width: "fit-content" }} onClick={() => { setSearchRecruitingState(prevState => { return !prevState }); }}>
          <FormControlLabel
            className='unselectable'
            style={{ pointerEvents: "none" }}
            label="Only Studies that are Recruiting"
            control={
              <Checkbox
                style={{ pointerEvents: "auto" }}
                checked={searchRecruitingState}
                onChange={(e) => { setSearchRecruitingState(e.target.checked); }}
                color="primary"
                label="Only Studies that are Recruiting"
                name="Only Studies that are Recruiting"
                inputProps={{ 'aria-label': 'Only Studies that are Recruiting' }}
              />
            }
          /></div>
        <br />
        {ctGovSearchResultsState?.length > 0 && <>
          <h3>{ctGovSearchResultsState.length} results from ClinicalTrials.gov search.</h3>
          {ctGovSearchResultsState.map((result, resultIndex) => {
            return <p key={resultIndex}>
              <a href={result.onClick} >{result.display}</a>
            </p>
          })}
        </>}
        {((ctGovSearchClicked || advancedCtGovSearchClicked) && ctGovSearchResultsState.length === 0) && <div>
          <h3>No results from ClinicalTrials.gov search.</h3>
        </div>}

        <span className={"unselectable"} style={{ cursor: "pointer" }}
          onClick={() => { setOpenAdvancedCTgovSearchState(!openAdvancedCTgovSearchState) }}>
          Advanced ClinicalTrials.gov Search (CTgov API version) -&nbsp;
          {openAdvancedCTgovSearchState ? <>Collapse ▼</> : <>Expand ►</>}</span>
        {openAdvancedCTgovSearchState && <>
          <br/>
          <TextField style={{ width: "70%", marginBottom: "8px" }} className="inputField" type='text' label={'Condition/disease'} size="small" variant='outlined' value={searchCondition} onChange={(e) => { setSearchCondition(e.target.value); }} />
          <TextField style={{ width: "70%", marginBottom: "8px" }} className="inputField" type='text' label={'Other terms'} size="small" variant='outlined' value={searchOtherTerms} onChange={(e) => { setSearchOtherTerms(e.target.value); }} />
          <TextField style={{ width: "70%", marginBottom: "8px" }} className="inputField" type='text' label={'Intervention/treatment'} size="small" variant='outlined' value={searchIntervention} onChange={(e) => { setSearchIntervention(e.target.value); }} />
          <TextField style={{ width: "70%", marginBottom: "8px" }} className="inputField" type='text' label={'Location'} size="small" variant='outlined' value={searchLocation} onChange={(e) => { setSearchLocation(e.target.value); }} />
          {/*titles (Title/acronym), outc (Outcome measure), spons (Sponsor/collaborator), lead (Lead sponsor name), patient (PatientSearch Area), id ("Study IDs" query in Essie expression syntax)*/}
          <br />
          <b>Study Status</b>
          &nbsp;&nbsp;
          <ToggleButtonGroup
            className="yesNoRadioCheckBoxSwitch extrathin"
            exclusive
            value={searchStudyStatus || ""}
            aria-label="Study Status"
            name="Study Status"
          >
            <ToggleButton className="yesButton" value="all" aria-label="All studies" color="success" style={{ fontSize: "11px" }} onClick={() => { setSearchStudyStatus("all"); }}>

              {searchStudyStatus === "all" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}

              All studies
            </ToggleButton>
            <ToggleButton className="otherButton" value="recruitingAndNotYet" aria-label="Recruiting and not yet recruiting studies" color="secondary" style={{ fontSize: "11px" }} onClick={() => { setSearchStudyStatus("recruitingAndNotYet"); }}>
              <span>
                {searchStudyStatus === "recruitingAndNotYet" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
              </span>
              Recruiting and not yet recruiting studies&nbsp;
            </ToggleButton>
          </ToggleButtonGroup>
          <br /><br />
          <b>Study Results</b>
          &nbsp;&nbsp;
          <ToggleButtonGroup
            className="genericToggleButtonGroup buttonGroupWrap extrathin"
            exclusive
            value={searchStudyResultsType}
            aria-label="Study Results"
            name="Study Results"
          >
            <ToggleButton className="genericToggleButton" color="primary"
              aria-label="All studies" value="all"
              onClick={() => { setSearchStudyResultsType("all"); }}>
              <span>
                {searchStudyResultsType === "all" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
              </span>
              All studies
            </ToggleButton>
            <ToggleButton className="genericToggleButton" color="primary"
              aria-label="With results" value="with"
              onClick={() => { setSearchStudyResultsType("with"); }}>
              <span>
                {searchStudyResultsType === "with" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
              </span>
              With results
            </ToggleButton>
            <ToggleButton className="genericToggleButton" color="primary"
              aria-label="Without results" value="without"
              onClick={() => { setSearchStudyResultsType("without"); }}>
              <span>
                {searchStudyResultsType === "without" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
              </span>
              Without results
            </ToggleButton>
          </ToggleButtonGroup>
          <br />
          <h4>Eligibility Criteria</h4>
          <ToggleButtonGroup
            className="genericToggleButtonGroup buttonGroupWrap extrathin"
            exclusive
            value={searchSex}
            aria-label="Sex"
            name="Sex"
          //onClick={(e) => { handleClick(e.target.value) }}
          >
            <ToggleButton className="genericToggleButton" color="primary"
              aria-label="All sexes" value="all"
              onClick={() => { setSearchSex("all"); }}>
              <span>
                {searchSex === "all" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
              </span>
              All sexes
            </ToggleButton>
            <ToggleButton className="genericToggleButton" color="primary"
              aria-label="Female" value="f"
              onClick={() => { setSearchSex("f"); }}>
              <span>
                {searchSex === "f" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
              </span>
              Female
            </ToggleButton>
            <ToggleButton className="genericToggleButton" color="primary"
              aria-label="Male" value="m"
              onClick={() => { setSearchSex("m"); }}>
              <span>
                {searchSex === "m" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
              </span>
              Male
            </ToggleButton>
          </ToggleButtonGroup>
          <br />
          Age range criteria coming soon...
          {/*TO DO: Age and age range*/}
          <br />
          <b>Accepts healthy volunteers</b>&nbsp;<Checkbox
            onChange={() => {
              setSearchAcceptsHealthyVolunteers(prevState => { return !prevState; });
            }}
            color="primary"
            style={{ paddingLeft: "4px", paddingRight: "4px" }}
          />
          <h4 style={{ marginTop: "6px", marginBottom: "0px" }}>Study Phase</h4>
          <div style={{ paddingLeft: "16px" }}>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchPhase0(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchPhase0} size="small" color="primary" /> <span>Early Phase 1</span></div>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchPhase1(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchPhase1} size="small" color="primary" /> <span>Phase 1</span></div>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchPhase2(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchPhase2} size="small" color="primary" /> <span>Phase 2</span></div>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchPhase3(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchPhase3} size="small" color="primary" /> <span>Phase 3</span></div>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchPhase4(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchPhase4} size="small" color="primary" /> <span>Phase 4</span></div>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchPhaseNA(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchPhaseNA} size="small" color="primary" /> <span>Phase NA</span></div>
          </div>
          <h4 style={{ marginTop: "6px", marginBottom: "0px" }}>Study Type</h4>
          <div style={{ paddingLeft: "16px" }}>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchStudyTypeInt(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchStudyTypeInt} size="small" color="primary" /> <span>Interventional</span></div>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchStudyTypeObs(prevState => { let checked = !prevState; if (!checked && searchStudyTypeObsPatReg) { setSearchStudyTypeObsPatReg(false); } return checked; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchStudyTypeObs} size="small" color="primary" /> <span>Observational</span></div>
            <div className="unselectable" style={{ cursor: "pointer", marginLeft: "16px" }} onClick={() => { setSearchStudyTypeObsPatReg(prevState => { let checked = !prevState; if (checked && !searchStudyTypeObs) { setSearchStudyTypeObs(true); } return checked; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchStudyTypeObsPatReg} size="small" color="primary" /> <span>Patient registries</span></div>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchStudyTypeExp(prevState => { let checked = !prevState; if (!checked) { if (searchStudyTypeExpIndiv) { setSearchStudyTypeExpIndiv(false); } if (searchStudyTypeExpInter) { setSearchStudyTypeExpInter(false); } if (searchStudyTypeExpTreat) { setSearchStudyTypeExpTreat(false); } } return checked; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchStudyTypeExp} size="small" color="primary" /> <span>Expanded Access</span></div>
            <div className="unselectable" style={{ cursor: "pointer", marginLeft: "16px" }} onClick={() => { setSearchStudyTypeExpIndiv(prevState => { let checked = !prevState; if (checked && !searchStudyTypeExp) { setSearchStudyTypeExp(true); } return checked; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchStudyTypeExpIndiv} size="small" color="primary" /> <span>Individual patients</span></div>
            <div className="unselectable" style={{ cursor: "pointer", marginLeft: "16px" }} onClick={() => { setSearchStudyTypeExpInter(prevState => { let checked = !prevState; if (checked && !searchStudyTypeExp) { setSearchStudyTypeExp(true); } return checked; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchStudyTypeExpInter} size="small" color="primary" /> <span>Intermediate-size population</span></div>
            <div className="unselectable" style={{ cursor: "pointer", marginLeft: "16px" }} onClick={() => { setSearchStudyTypeExpTreat(prevState => { let checked = !prevState; if (checked && !searchStudyTypeExp) { setSearchStudyTypeExp(true); } return checked; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchStudyTypeExpTreat} size="small" color="primary" /> <span>Treatment IND/Protocol</span></div>
          </div>
          <h4 style={{ marginTop: "6px", marginBottom: "0px" }}>Study Documents</h4>
          <div style={{ paddingLeft: "16px" }}>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchDocumentsProtocols(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchDocumentsProtocols} size="small" color="primary" /> <span>Study protocols</span></div>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchDocumentsSAPs(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchDocumentsSAPs} size="small" color="primary" /> <span>Statistical analysis plans (SAPs)</span></div>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchDocumentsICFs(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchDocumentsICFs} size="small" color="primary" /> <span>Informed consent forms (ICFs)</span></div>
          </div>
          <h4 style={{ marginTop: "6px", marginBottom: "0px" }}>Funder Type</h4>
          <div style={{ paddingLeft: "16px" }}>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchFunderNIH(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchFunderNIH} size="small" color="primary" /> <span>NIH</span></div>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchFunderFed(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchFunderFed} size="small" color="primary" /> <span>Other U.S. federal agency</span></div>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchFunderIndustry(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchFunderIndustry} size="small" color="primary" /> <span>Industry</span></div>
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchFunderOther(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchFunderOther} size="small" color="primary" /> <span>All others (individuals, universities, organizations)</span></div>
          </div>
          <h4 style={{ marginTop: "6px", marginBottom: "0px" }}>Date Range</h4>
          <div style={{ paddingLeft: "16px" }}>Date range search coming soon...</div>
          <h4 style={{ marginTop: "6px", marginBottom: "0px" }}>More Ways to Search</h4>
          <div style={{ paddingLeft: "16px" }}>
            <TextField style={{ width: "70%", marginBottom: "8px" }} className="inputField" type='text' label={'Title and/or Title Acronym'} size="small" variant='outlined' value={searchTitles} onChange={(e) => { setSearchTitles(e.target.value); }} />
            <TextField style={{ width: "70%", marginBottom: "8px" }} className="inputField" type='text' label={'Outcome measure'} size="small" variant='outlined' value={searchOutcomeMeasure} onChange={(e) => { setSearchOutcomeMeasure(e.target.value); }} />
            <TextField style={{ width: "70%", marginBottom: "8px" }} className="inputField" type='text' label={'Sponsor and/or Collaborator'} size="small" variant='outlined' value={searchSponsor} onChange={(e) => { setSearchSponsor(e.target.value); }} />
            <TextField style={{ width: "70%", marginBottom: "8px" }} className="inputField" type='text' label={'Sponsor (Lead)'} size="small" variant='outlined' value={searchLeadSponsor} onChange={(e) => { setSearchLeadSponsor(e.target.value); }} />
            <TextField style={{ width: "70%", marginBottom: "8px" }} className="inputField" type='text' label={'Study IDs'} size="small" variant='outlined' value={searchStudyIds} onChange={(e) => { setSearchStudyIds(e.target.value); }} /> {/*Do we need this field or can it be removed?*/}
              <br/>
              
            <div className="unselectable" style={{ cursor: "pointer" }} onClick={() => { setSearchFDAAAViolations(prevState => { return !prevState; }); }}><Checkbox style={{ padding: "0px 0px 4px 0px" }} checked={searchFDAAAViolations} size="small" color="primary" /> <span>Yes, has FDAAA 801 Violations</span></div>
            {/*TO DO Facility Name, I'm not sure how this is different from Location in the API documentation.*/}
          </div>
          <br/>
          {/*After clicking I Should make it so the whole page turns grey, and if there are results it should bring you to the top of the page. */}
          <Button className="formButton positive" content="Advanced Search" compact onClick={() => {
              advancedCtGovSearch();
          }} disabled={loading} />
        </>}

        <br />
        <br />
        <span className={"unselectable"} style={{ cursor: "pointer" }}
          onClick={() => { setOpenAdvancedCTgovSearchState(!openAdvancedCTgovSearchState) }}>
          Advanced ClinicalTrials.gov Search (IN DEVELOPMENT) -&nbsp;
          {openAdvancedCTgovSearchState ? <>Collapse ▼</> : <>Expand ►</>}</span>
        {openAdvancedCTgovSearchState && <>
          <br />
          <br />
          <p>THIS FUNCTION IS IN DEVELOPMENT AND NOT READY FOR USE YET.</p>
          <span>
            <Button style={{ color: "#000000", width: "360px", float: "left" }} className="formButton"
              content="Search"
              onClick={advancedCtGovSearchClick} />
          </span>
          <br />
          <br />
          <span>
            <TextField className="inputField" type='text' label={'Simple Search String'}
              size="small" style={{ width: "75%" }}
              variant='outlined' value={advancedCTgovSearchState.simpleString || ""} onKeyUp={handleAdvancedCTgovKeyUp}
              onChange={(e) => {
                setAdvancedCTgovSearchState(prevState => {
                  return { ...prevState, "simpleString": e.target.value }
                });
              }} />
          </span>
          <br />
          <br />
          <span>
            <TextField className="inputField" type='text' label={'NCTID'}
              size="small" style={{ width: "25%" }}
              variant='outlined' value={advancedCTgovSearchState.nctid || ""} onKeyUp={handleAdvancedCTgovKeyUp}
              onChange={(e) => {
                setAdvancedCTgovSearchState(prevState => {
                  return { ...prevState, "nctid": e.target.value }
                });
              }} />
          </span>
          <br />
          <br />
          <span>
            <TextField className="inputField" type='text' label={'Title (or acronym) includes'}
              size="small" style={{ width: "25%" }}
              variant='outlined' value={advancedCTgovSearchState.titleAcronym || ""}
              onChange={(e) => {
                setAdvancedCTgovSearchState(prevState => {
                  return { ...prevState, "titleAcronym": e.target.value }
                });
              }} />
          </span>
          <br />
          <br />
          <span>
            <DataEntry datatype='Period' elementName='originalPostingDate' fieldLabel='Original posting date (Range)'
              startingValue={advancedCTgovSearchState.originalPostingDate || null}
              setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>
            <DataEntry datatype='Period' elementName='lastUpdatedDate' fieldLabel='Record last updated date (Range)'
              startingValue={advancedCTgovSearchState.lastUpdatedDate || null}
              setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>
            <DataEntry datatype='Period' elementName='studyStartDate' fieldLabel='Study start date (Range)'
              startingValue={advancedCTgovSearchState.studyStartDate || null}
              setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>
            <DataEntry datatype='Period' elementName='studyEndDate' fieldLabel='Study end date (Range)'
              startingValue={advancedCTgovSearchState.studyEndDate || null}
              setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>
            <DataEntry asArray={true} datatype='code' elementName='studyStatus' fieldLabel='Study status'
              allowedValues={["COMPLETED", "NOT STARTED", "RECRUITING", "ACTIVE", "TERMINATED"]}
              dataEntryStyle='dropdownsearch'
              startingValue={advancedCTgovSearchState.studyStatus || []}
              setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>
            <DataEntry asArray={true} datatype='string' elementName='locationName'
              fieldLabel='Site(s) include (by name)'
              startingValue={advancedCTgovSearchState.locationName || []}
              setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>
            <DataEntry asArray={true} datatype='string' elementName='locationCountry'
              fieldLabel='Site(s) include (by country)'
              startingValue={advancedCTgovSearchState.locationCountry || []}
              setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>Location by geopositioning - PLACEHOLDER - search for within N miles/km from selected spot</span>
          <br />
          <br />
          <span>
            <DataEntry asArray={true} datatype='string' elementName='keywords'
              fieldLabel='Keywords include'
              startingValue={advancedCTgovSearchState.keywords || []}
              setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>
            <DataEntry asArray={true} datatype='string' elementName='populations'
              fieldLabel='Populations/Conditions include'
              startingValue={advancedCTgovSearchState.populations || []}
              setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>
            <DataEntry asArray={true} datatype='string' elementName='interventions'
              fieldLabel='Interventions include'
              startingValue={advancedCTgovSearchState.interventions || []}
              setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>
            <DataEntry datatype='Range' elementName='ageRange' fieldLabel='Age Range'
              startingValue={advancedCTgovSearchState.ageRange || null}
              setResourceState={setAdvancedCTgovSearchState}
              dataEntryStyle='Age' />
          </span>
          <br />
          <br />
          <span>
            <DataEntry datatype='boolean' elementName='volunteers'
              fieldLabel='Accepts healthy volunteers?'
              storeFalse={true}
              startingValue={advancedCTgovSearchState.volunteers} setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>Search by phase
            <DataEntry asArray={true} datatype='code' elementName='phase' fieldLabel='Study phase'
              allowedValues={["Phase 1", "Phase 1/Phase 2", "Phase 2", "Phase 2/Phase 3", "Phase 3"]}
              dataEntryStyle='dropdownsearch'
              startingValue={advancedCTgovSearchState.phase || []}
              setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>
            <DataEntry asArray={true} datatype='code' elementName='studyType' fieldLabel='Study type includes'
              allowedValues={["INTERVENTIONAL", "OBSERVATIONAL", "OTHER"]}
              dataEntryStyle='dropdownsearch'
              startingValue={advancedCTgovSearchState.studyType || []}
              setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>
            <DataEntry asArray={true} datatype='code' elementName='studyDesign' fieldLabel='Study design includes'
              allowedValues={["Randomized assignment", "Crossover", "Open study (no blinding)", "Blinding of participants", "Blinding of clinicians"]}
              dataEntryStyle='dropdownsearch'
              startingValue={advancedCTgovSearchState.studyDesign || []}
              setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>
            <DataEntry datatype='boolean' elementName='hasResults'
              fieldLabel='Study has results?'
              storeFalse={true}
              startingValue={advancedCTgovSearchState.hasResults} setResourceState={setAdvancedCTgovSearchState} />
          </span>
          <br />
          <br />
          <span>
            <Button style={{ color: "#000000", width: "360px", float: "left" }} className="formButton"
              content="Search"
              onClick={advancedCtGovSearchClick} />
          </span>
          <br />
        </>}
      </Segment>
    </div>
  );
};

export default CTgovConvertPage;